import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from '@phosphor-icons/react';
import axios from 'axios';
import { API, CONTACT_INFO } from '../App';

const BarMobile = () => {
  const [concepts, setConcepts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchConcepts = async () => {
      try {
        const response = await axios.get(`${API}/concepts`);
        setConcepts(response.data);
      } catch (error) {
        console.error('Failed to fetch concepts:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchConcepts();
  }, []);

  return (
    <div className="bg-black min-h-screen">
      {/* Hero with Background Image */}
      <section className="relative min-h-[60vh] flex items-center justify-center">
        {/* Background Image */}
        <div className="absolute inset-0 z-0">
          <img
            src="https://customer-assets.emergentagent.com/job_signature-studio-4/artifacts/n4pr8rxb_Capture%20d%E2%80%99e%CC%81cran%202026-05-11%20a%CC%80%2011.03.55.png"
            alt="Détail bar"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/60"></div>
        </div>
        
        {/* Content */}
        <div className="relative z-10 max-w-4xl mx-auto text-center px-6 lg:px-12 py-24">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-white mb-4">
              Bars prêts à installer
            </h1>
            <div className="w-16 h-px bg-white/50 mx-auto mt-6"></div>
            <p className="text-sm uppercase tracking-wider text-white/70 mt-6">Bar Mobile</p>
            <p className="text-lg text-white/80 leading-relaxed max-w-2xl mx-auto mt-6">
              Nos bars prêts à installer sont conçus pour offrir une solution élégante, rapide et opérationnelle. Ils s'intègrent dans différents formats d'événements tout en garantissant un rendu visuel haut de gamme.
            </p>
            <p className="text-base text-white/60 italic max-w-2xl mx-auto mt-4">
              Disponibles en prestation complète ou en mise à disposition pour professionnels.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Bars Grid - Alternating Layout */}
      <section className="section-white py-16 px-6 lg:px-12">
        <div className="max-w-6xl mx-auto">
          {loading ? (
            <div className="flex justify-center py-20">
              <div className="spinner" style={{ borderTopColor: '#000' }} />
            </div>
          ) : (
            <div className="space-y-32">
              {concepts.map((concept, index) => (
                <motion.div
                  key={concept.id}
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.8 }}
                  className={`grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center`}
                >
                  {/* Image */}
                  <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                    <Link to={`/bar-mobile/${concept.id}`} className="block group">
                      <div className="aspect-square overflow-hidden bg-gray-100">
                        <img
                          src={concept.image_url}
                          alt={concept.title}
                          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                        />
                      </div>
                    </Link>
                  </div>

                  {/* Content */}
                  <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                    <h2 className="font-display text-3xl lg:text-4xl text-black mb-4">
                      {concept.title}
                    </h2>
                    <p className="text-gray-500 text-lg mb-6">{concept.subtitle}</p>
                    <p className="text-gray-600 leading-relaxed mb-8">
                      {concept.description}
                    </p>
                    <Link 
                      to={`/bar-mobile/${concept.id}`}
                      className="inline-flex items-center gap-2 text-black hover:opacity-60 transition-opacity"
                    >
                      <span className="text-sm uppercase tracking-wider">Voir les détails</span>
                      <ArrowRight size={16} weight="light" />
                    </Link>
                  </div>
                </motion.div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* SEO Text - Bold white on black */}
      <section className="bg-black py-20 px-6 lg:px-12">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-white text-xl lg:text-2xl font-semibold">
            Des bars scénographiés à partir de 2,40 m, modulables et pensés pour s'intégrer à chaque événement ou prestation professionnelle.
          </p>
        </div>
      </section>
    </div>
  );
};

export default BarMobile;
